// Agrega un leading zero si el número es menor a 10
export function leadingZero(val) {
    if (val<10) {
        return '0'+val;
    }
    else {
        return val;
    }
}

// Recibe el componente de hora en formato militar y lo devuelve en formato am/pm
export function getHoraCita(data) {
    let valorHora = parseInt(data);
    if (valorHora === 0) {
        return '12';
    }
    if (valorHora>12) {
        valorHora = valorHora - 12;
    }
    if (valorHora<10) {
        valorHora = '0'+valorHora;
    }
    return ''+valorHora;
}

// Recibe el componente de hora en formato militar y devuelve am o pm
export function getAmpm(data) {
    let valorHora = parseInt(data);
    let ampm = "am";
    if (valorHora>=12) {
        ampm = "pm";
    }
    return ampm;
}

// Recibe hora y minutos en formato militar y devuelve un array con formato hh:mm:am/pm
export function getElementosHora(data) {
    let arrayTiempo = data.split(':');
    let componenteHora = arrayTiempo[0];
    let componenteMinutos = arrayTiempo[1];
    let componenteAmpm = 'am';
    if (parseInt(componenteHora)>12) {
        componenteHora = parseInt(componenteHora) - 12;
        componenteAmpm = 'pm';
        if (componenteHora<10) {
            componenteHora = '0'+componenteHora;
        }
    }
    else if (parseInt(componenteHora)===12) {
        componenteAmpm = 'pm';
    }
    else if (parseInt(componenteHora)===0) {
        componenteHora = '12';
        componenteAmpm = 'am';
    }
    return [ ''+componenteHora, componenteMinutos, componenteAmpm ];
}

/** Ordena citas por fecha y luego hora, ambos ascendente (YYYY-MM-DD y HH:MM:SS). */
export function ordenarCitasPorFechaHoraAsc(lista) {
    if (!Array.isArray(lista)) return [];
    return [...lista].sort((a, b) => {
        const cmpFecha = String(a.fecha_cita ?? '').localeCompare(String(b.fecha_cita ?? ''));
        if (cmpFecha !== 0) return cmpFecha;
        return String(a.hora_cita ?? '').localeCompare(String(b.hora_cita ?? ''));
    });
}

// Convierte hora militar (HH:MM) a formato 12h (HH:MM AM/PM)
export function convertirHoraMilitarA12h(horaMilitar) {
    if (!horaMilitar) return '';
    
    const elementos = getElementosHora(horaMilitar);
    return `${elementos[0]}:${elementos[1]} ${elementos[2].toUpperCase()}`;
}

// Convierte hora militar a formato 12h para etiquetas de agenda
export function convertirHoraEtiqueta(valorHora) {
    if (valorHora === 0) return '12:00&nbsp;AM';
    if (valorHora < 12) return `${valorHora}:00&nbsp;AM`;
    if (valorHora === 12) return '12:00&nbsp;PM';
    return `${valorHora - 12}:00&nbsp;PM`;
}

// Obtiene la hora de inicio en minutos transcurridos del día...
export function getHoraInicio(hora) {
    let h = parseInt(hora.split(':')[0]);
    let m = parseInt(hora.split(':')[1]);
    return (h*60)+m;
}

// obtiene la hora de fin en minutos transcurridos del día...
export function getHoraFin(hora,duracion) {
    return parseInt(getHoraInicio(hora)) + parseInt(duracion);
}

// Valida si el archivo especificado es una imagen de tipo jpg o png
export function validarArchivoEsImagen(file) {

    let f = file.name.split(".");
    let ext = f[f.length-1];

    if (ext!=='jpg'&&ext!=='png'&&ext!=='jpeg') {
        return false;
    }
    else {
        return true;
    }
}

/**
 * Fecha local desde dateClick de FullCalendar (vista mensual envía dateStr "YYYY-MM-DD" en UTC).
 */
export function parseDateClickCalendario(info) {
    if (info && info.date instanceof Date && !Number.isNaN(info.date.getTime())) {
        return info.date;
    }
    const str = String((info && info.dateStr) || '');
    const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        const y = parseInt(match[1], 10);
        const m = parseInt(match[2], 10) - 1;
        const d = parseInt(match[3], 10);
        if (str.length > 10 && /T\d/.test(str)) {
            const conHora = new Date(str);
            if (!Number.isNaN(conHora.getTime())) {
                return conHora;
            }
        }
        return new Date(y, m, d);
    }
    return new Date(str);
}

// Recibe un objeto Date y devuelve un string con la fecha en formato dd/mm/yyyy
export function formatFecha(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        date = new Date(date);
    }
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    var day = date.getDate();
    if (day < 10) {
        day = "0" + day;
    }
    var month = date.getMonth() + 1;
    if (month < 10) {
        month = "0" + month;
    }
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
}


export function getFechaActual() {

    let hoy = new Date();
    return hoy.getFullYear()+'-'+(leadingZero(hoy.getMonth() + 1))+'-'+leadingZero(hoy.getDate());
}


export const escalarImagen = (ancho, alto, anchoMax, altoMax) => {

    let nuevoAncho = parseInt(anchoMax);
    let nuevoAlto = parseInt(altoMax);

    if (ancho>alto) {
        nuevoAlto = Math.floor((alto/ancho)*anchoMax);
    }   
    else {
        nuevoAncho = Math.floor((ancho/alto)*altoMax);
    }

    return { ancho: nuevoAncho, alto: nuevoAlto};
}


// 🔧 CORRECCIÓN: Comparación case-insensitive para categorías de permisos
export function getPermisosPorCategoria(listaPermisos,categoria) {
    let resultado = [];
    for (let k=0;k<listaPermisos.length;k++) {
        // Comparar en minúsculas para evitar problemas de case-sensitivity
        if (listaPermisos[k].categoria && listaPermisos[k].categoria.toLowerCase() === categoria.toLowerCase()) {
            resultado.push(listaPermisos[k]);
        }
    }

    return resultado;
}

export const usuarioTieneFirma = () => {
    const raw = localStorage.getItem('userdata');
    if (!raw) {
        return false;
    }
    try {
        const userdata = JSON.parse(raw);
        return Boolean(userdata?.firma);
    } catch {
        return false;
    }
}

export const usuarioTieneRegistro = () => {
    const raw = localStorage.getItem('userdata');
    if (!raw) {
        return false;
    }
    try {
        const userdata = JSON.parse(raw);
        return Boolean(userdata?.registro);
    } catch {
        return false;
    }
}


export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}



export function citaSeCruza(fecha, hora, duracion, citas) {

    let hi2 = getHoraInicio(hora);
    let hf2 = getHoraFin(hora,duracion);
    
    // Se recorre el array de citas existentes
    for (let i=0;i<citas.length;i++) {
        let cita = citas[i];
        let hi1 = getHoraInicio(cita.hora_cita);
        let hf1 = getHoraFin(cita.hora_cita,cita.duracion_cita);

        // Si la hora de inicio y de fin son diferentes, entonces validar los cruces...
        if (hi1!=hi2&&hf1!=hf2) {
            // Se hacen las comparaciones para detectar los cruces...
            if ((hi1>hi2&&hi1<hf2)||(hi2>hi1&&hf2<hf1)||(hi2<hf1&&hf2>hf1)||(hi1>hi2&&hf1<hf2)) {
                return true;
            }
        }
        else {
            return true;
        }
    }

    return false;
}


export function citaExistenteSeCruza(fecha, hora, duracion, idCita, citas) {

    let hi2 = getHoraInicio(hora);
    let hf2 = getHoraFin(hora,duracion);
    
    // Se recorre el array de citas existentes
    for (let i=0;i<citas.length;i++) {
        let cita = citas[i];
        // Si las citas son diferentes entonces se hace la comparación para detectar si las citas se cruzan; 
        // Si las citas son iguales no se hace la comparación y la función devuelve false.
        if (idCita!=cita.id) {
            let hi1 = getHoraInicio(cita.hora_cita);
            let hf1 = getHoraFin(cita.hora_cita,cita.duracion_cita);
            
            if (hi1!=hi2&&hf1!=hf2) {
                if ((hi1>hi2&&hi1<hf2)||(hi2>hi1&&hf2<hf1)||(hi2<hf1&&hf2>hf1)||(hi1>hi2&&hf1<hf2)) {
                    return true;
                }
            }
            else {

                return true;
            }
        }
    }

    return false;
}



export const sexoBiologico = {
    '01':'HOMBRE',
    '02':'MUJER',
    '03':'INDETERMINADO/INTERSEXUAL'
}

export const identidadesGenero = {
    '01':'MASCULINO',
    '02':'FEMENINO',
    '03':'TRANSGENERO',
    '04':'NEUTRO',
    '05':'NO LO DECLARA'
}

export const discapacidades = {
    '01':'FISICA',
    '02':'VISUAL',
    '03':'AUDITIVA',
    '04':'INTELECTUAL',
    '05':'SICOSOCIAL (MENTAL)',
    '06':'SORDOCEGUERA',
    '07':'MULTIPLE',
    '08':'NINGUNA'
}

export const etnias = {
    '01':'INDIGENA',
    '02':'ROM (GITANO)',
    '03':'RAIZAL',
    '04':'PALENQUERO',
    '05':'NEGRO',
    '06':'AFROCOLOMBIANO',
    '99':'NINGUNA DE LAS ANTERIORES'
}

export const tiposDocumento = {
    'CC':'CEDULA DE CIUDADANIA',
    'CE':'CEDULA DE EXTRANJERIA',
    'CD':'CARNET DIPLOMATICO',
    'CN':'CERTIFICADO DE NACIDO VIVO',
    'DE':'DOCUMENTOS EXTRANJERO',
    'MS':'MENOR SIN IDENTIFICAR',
    'NIP':'NUMERO DE IDENTIFICACION PERSONAL',
    'NIT':'NUMERO DE IDENTIFICACION TRIBUTARIA',
    'PA':'PASAPORTE',
    'PT':'PERMISO TEMPORAL DE PERMANENCIA',
    'PE':'PERMISO ESPECIAL DE PERMANENCIA',
    'RC':'REGISTRO CIVIL',
    'TI':'TARJETA DE IDENTIDAD',
    'SC':'SALVOCONDUCTO DE PERMANENCIA',
    'SI':'SIN IDENTIFICACION',
    'AS':'ADULTO SIN IDENTIFICAR'
}


export const escolaridades = [
    { id:'preescolar', nombre:'PREESCOLAR'},
    { id:'primaria', nombre:'PRIMARIA'},
    { id:'secundaria', nombre:'SECUNDARIA'},
    { id:'bachillerato', nombre:'BACHILLERATO'},
    { id:'superior', nombre:'SUPERIOR'},
    { id:'maestria', nombre:'MAESTRIA'},
    { id:'doctorado', nombre:'DOCTORADO'}
]